import { render } from "./WebsiteConfig.vue?vue&type=template&id=65a57447&scoped=true&ts=true"
import script from "./WebsiteConfig.vue?vue&type=script&lang=ts"
export * from "./WebsiteConfig.vue?vue&type=script&lang=ts"

import "./WebsiteConfig.vue?vue&type=style&index=0&id=65a57447&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a57447"]])

export default __exports__